import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { Menu, Dropdown, Icon, Table } from "antd";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import editIcon from "../../../../assets/images/budget/dropdown.png";
import menuIcon from "../../../../assets/images/DeathModuleNew/Menu.png";
import NewLoader from "../../../../components/styled-components/loader/NewLoader";
import swal from "sweetalert";
import { AddTransactionRules } from "./AddTransactionRules";
import BUDGET_API from "../../../../apis/budget.api";
import DEATH_API from "../../../../apis/death.api";
import { Modal } from "antd";
import moment from "moment";

export const TransactionRules = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [formData, setFormData] = useState(null);
  const [clientBanks, setClientBanks] = useState(null);
  const [categories, setCategories] = useState(null);
  const [detailsModal, setDetailsModal] = useState(false);
  const [affectedTransactions, setAffectedTransactions] = useState(null);

  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [transactionrules, setTransactionRules] = useState([]);
  const [cachedData, setCachedData] = useState({});
  const [transactionRuleId, setTransactionRuleId] = useState(null);
  const [selectedTab, setSelectedTab] = useState("Before");
  const [modalTitle, setModalTitle] = useState("Add Rule");
  const [searchQuery, setSearchQuery] = useState("");
  const requestId = useRef(0);

  const handleCancel = () => {
    setDetailsModal(false);
    setAffectedTransactions(null);
    setTransactionRuleId(null);
    setSelectedTab("Before");
  };

  const handleApplyRule = async () => {
    try {
      setLoading(true);
      const affectedTransactionIds = affectedTransactions.map((txn) => txn.id);
      let payload = {
        ruleId:
          transactionRuleId && transactionRuleId.id && transactionRuleId.id,
        transactionIds: affectedTransactionIds,
      };
      let data = await BUDGET_API.updateRuleBasedTransactions(payload);
      if (data && data.status === 200) {
        swal("Success", data.message, "success");
      }
      if (data && data.status === 400) {
        swal("Error", data.message, "error");
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }

    setDetailsModal(false);
    setAffectedTransactions(null);
    setTransactionRuleId(null);
    setSelectedTab("Before");
  };

  const getAffectedRecords = async (payloadData, createData) => {
    setDetailsModal(true);
    try {
      setLoading(true);
      const ruleId = payloadData.id;
      let data = await BUDGET_API.fetchAllRuleBasedTransaction(ruleId);
      if (data && data.data) {
        setAffectedTransactions(data.data);
        let rule = {
          ...payloadData,
          categoryName:
            createData && createData.categoryName && createData.categoryName,
          subCategory:
            createData && createData.subCategory && createData.subCategory,
        };
        setTransactionRuleId(rule);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleInputChange = (name, value) => {
    if (name === "category") {
      console.log("value", value);
      if (value.includes("-")) {
        const [subcategoryName, categoryName] = value
          .split("-")
          .map((item) => item.trim());
        console.log("Subcategory Name:", subcategoryName);
        console.log("Category Name:", categoryName);

        // Find category and subcategory IDs
        let categoryId = null;
        let subcategoryId = null;
        categories &&
          categories.forEach((category) => {
            if (category.categoryName === categoryName) {
              categoryId = category.id;
              const subcategory =
                category.subCategories &&
                category.subCategories.find(
                  (sub) => sub.name === subcategoryName
                );
              if (subcategory) {
                subcategoryId = subcategory.id;
              }
            }
          });

        console.log("Category ID:", categoryId);
        console.log("Subcategory ID:", subcategoryId);
        setFormData({
          ...formData,
          // ["changeCategoryTo"]: subcategoryId,
          ["changeCategoryTo"]: categoryId,
          ["categoryName"]: categoryName,
          ["categoryId"]: categoryId,
          ["changeSubCategoryTo"]: subcategoryId,
          ["subCategory"]: subcategoryName,
          ["category"]: subcategoryName,
        });
      } else {
        let categoryId = null;
        categoryId =
          categories &&
          categories.find((item) => item.categoryName === value).id;
        setFormData({
          ...formData,
          ["changeCategoryTo"]: categoryId,
          ["category"]: value,
          ["categoryName"]: value,
          ["categoryId"]: categoryId,
          ["changeSubCategoryTo"]: null,
        });
      }
    }
    if (name === "moneyCondition") {
      if (value === "Money In") {
        setFormData({
          ...formData,
          ["moneyIn"]: true,
          ["moneyOut"]: false,
          [name]: value,
        });
      }
      if (value === "Money Out") {
        setFormData({
          ...formData,
          ["moneyIn"]: false,
          ["moneyOut"]: true,
          [name]: value,
        });
      }
      if (value === "Both") {
        setFormData({
          ...formData,
          ["moneyIn"]: true,
          ["moneyOut"]: true,
          [name]: value,
        });
      }
    } else {
      if (name !== "category") {
        setFormData({
          ...formData,
          [name]: value,
        });
      }
    }
  };
  const handleCancelRule = () => {
    setAddModal(false);
    setFormData(null);
    setModalTitle("Add Rule");
  };
  const handleUpdateRule = (record) => {
    console.log("record:", record);

    let updatedRecord = { ...record };

    // Determine moneyCondition
    if (record.moneyIn && !record.moneyOut) {
      updatedRecord.moneyCondition = "Money In";
    } else if (record.moneyOut && !record.moneyIn) {
      updatedRecord.moneyCondition = "Money Out";
    } else if (record.moneyIn && record.moneyOut) {
      updatedRecord.moneyCondition = "Both";
    }

    // Determine category or subcategory name
    if (record.changeCategoryTo || record.changeSubCategoryTo) {
      let categoryName = null;

      if (record.changeSubCategoryTo) {
        // Find the subcategory first if `changeSubCategoryTo` exists
        const subcategory =
          categories &&
          categories
            .flatMap((cat) => cat.subCategories || [])
            .find((sub) => sub.id === record.changeSubCategoryTo);

        if (subcategory) {
          categoryName = subcategory.name;
        }
      } else if (record.changeCategoryTo) {
        // If `changeSubCategoryTo` doesn't exist, check the main category
        const category =
          categories &&
          categories.find((item) => item.id === record.changeCategoryTo);

        if (category) {
          categoryName = category.categoryName;
        }
      }

      if (categoryName) {
        updatedRecord.category = categoryName;
      }
    }

    // Update form data once
    setFormData(updatedRecord);

    setModalTitle("Update Rule");
    setAddModal(true);
  };

  const deleteRule = async (record) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this Transaction Rule?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, Delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          let payload = { ...record, enable: false, deleted: true };
          let res = await BUDGET_API.deleteTransactionRule(payload.id);
          if (res && res.status === 200) {
            setCachedData({});
            await getRulesAfterDelete(1);
            swal(
              "Deleted!",
              "Your Transaction Rule has been deleted.",
              "success"
            );
          }
          setLoading(false);
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
      } else {
        swal("Cancelled", "Your Transaction Rule is safe :)", "error");
      }
    });
  };
  const handleSaveRule = async () => {
    console.log("formData", formData, modalTitle);
    if (
      formData &&
      formData.nameCondition &&
      (!formData.nameToMatch || !formData.nameToMatch.trim())
    ) {
      swal("Error", "Please enter a value for Name to Match.", "error");
      return;
    }

    if (
      formData &&
      formData.amountCondition &&
      (!formData.amountToMatch || !formData.amountToMatch.toString().trim())
    ) {
      swal("Error", "Please enter a value for Amount to Match.", "error");
      return;
    }
    setAddModal(false);
    let accountId = null;
    if (modalTitle === "Add Rule") {
      try {
        let payload = {
          ...formData,
        };
        if (payload && !payload.moneyIn && !payload.moneyOut) {
          payload.moneyIn = false;
          payload.moneyOut = false;
        }
        if (
          formData &&
          formData.appliedTo &&
          formData.appliedTo != "all"
        ) {
          accountId =
            clientBanks &&
            clientBanks.find(
              (item) => item.accountTitle === formData.appliedTo
            ).bankId;
          payload.account = accountId;
        }
        setLoading(true);
        let data = await BUDGET_API.addTransactionRule(payload);
        if (data && data.status === 201) {
          if (data.transations) {
            // swal(
            //   "Success",
            //   `${data.message} ${data.transations} Transations Affected by this Rule`,
            //   "success"
            // );
            if (data.data && data.data.id) {
              await getAffectedRecords(data.data, payload);
            }
          } else {
            swal("Success", data.message, "success");
          }
          await getRulesAfterDelete(1);
        }
        if (data && data.status === 400) {
          swal("Error", data.message, "error");
        }
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    } else {
      try {
        let payload = {
          ...formData,
        };
        if (
          formData &&
          formData.appliedTo &&
          formData.appliedTo != "all"
        ) {
          accountId =
            clientBanks &&
            clientBanks.find(
              (item) => item.accountTitle === formData.appliedTo
            ).bankId;
          payload.account = accountId;
        }
        setLoading(true);
        let data = await BUDGET_API.updateTransactionRule(payload);
        if (data && data.status === 200) {
          setCachedData({});
          if (data.data && data.data) {
            await getAffectedRecords(data.data, payload);
          }
          await getRulesAfterDelete(1);
          swal("Success", data.message, "success");
        }
        if (data && data.status === 400) {
          swal("Error", data.message, "error");
        }
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    }
    setFormData(null);
    setModalTitle("Add Rule");
  };
  const getCategories = async () => {
    try {
      setLoading(true);
      let data = await DEATH_API.getCategories("false");
      if (data && data.status === 200 && data.data) {
        setCategories(data.data);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getBankDetails = async () => {
    try {
      setLoading(true);
      let data = await DEATH_API.getBankDetails();
      let obj = [];
      let bankData = {};
      if (data && data.data) {
        const newArray = data.data.map((account) => {
          return {
            bankId: account.id,
            accountId: account.accountId,
            accountName: `${account.accountName}`,
            bankName: account.bankName,
            subType: account.subType,
            accountNumber: account.mask,
            accountTitle: `${account.accountName} ${account.mask}`,
            balance: account.balance,
          };
        });
        console.log("newArray", newArray);
        setClientBanks([
          ...newArray,
          {
            accountId: 1234,
            accountName: "cash",
            bankName: "devbank",
            subType: "debsubtype",
            accountNumber: 1122,
            accountTitle: "Cash",
            balance: 1111,
          },
        ]);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const updateStateWithData = (datares) => {
    console.log("datares", datares.data);
    if (datares && datares.data) {
      const sortedData = [...datares.data].sort((a, b) => {
        if (a.priority !== undefined && b.priority !== undefined) {
          return a.priority - b.priority;
        }
        return 0; // Keep original order if priority doesn't exist
      });
      setTransactionRules(sortedData);
    }
    if (datares && datares.total) {
      setTotalPages(Math.ceil(datares.total / 10));
    }
  };
  const getTransactionsRules = async (page, search = "") => {
    const currentRequestId = ++requestId.current;
    if (!search && cachedData && cachedData[page]) {
      setLoading(false);
      updateStateWithData(cachedData[page]);
      return;
    }
    try {
      setLoading(true);
      let data = await BUDGET_API.fetchTransactionsRules(page, search);
      if (currentRequestId !== requestId.current) return;
      console.log("data rules", data.data);
      if (data && data.data) {
        if (!search) {
          setCachedData((prevState) => ({
            ...prevState,
            [page]: data,
          }));
        }
        updateStateWithData(data);
      }
      setLoading(false);
    } catch (error) {
      if (currentRequestId !== requestId.current) return;
      console.log(error);
      setLoading(false);
    }
  };
  const getRulesAfterDelete = async (page) => {
    try {
      setLoading(true);
      let data = await BUDGET_API.fetchTransactionsRules(page);
      if (data && data.data) {
        setCachedData((prevState) => ({
          ...prevState,
          [page]: data,
        }));
        updateStateWithData(data);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getAll = async () => {
    await getCategories();
    await getBankDetails();
  };
  useEffect(() => {
    getTransactionsRules(currentPage, searchQuery);
  }, [currentPage, searchQuery]);
  useEffect(() => {
    getAll();
  }, []);
  const onDragEnd = (result) => {
    if (
      !result.destination ||
      result.source.index === undefined ||
      result.destination.index === undefined
    )
      return;

    const newData = transactionrules && [...transactionrules];
    const [movedItem] = newData.splice(result.source.index, 1);
    newData.splice(result.destination.index, 0, movedItem);
    const updatedData = newData.map((item, index) => ({
      ...item,
      priority: index + 1, // Assign new index as priority
    }));
    const updatedMovedItem = updatedData.find(
      (item) => item.id === movedItem.id
    );
    handleUpdatePriority(updatedMovedItem);
    console.log("newData", updatedData);
    setTransactionRules(updatedData);
  };
  const handleUpdatePriority = async (payload) => {
    try {
      setLoading(true);
      let data = await BUDGET_API.updateTransactionRule(payload);
      if (data && data.status === 200) {
        setCachedData({});
        await getRulesAfterDelete(1);
        swal("Success", data.message, "success");
      }
      if (data && data.status === 400) {
        swal("Error", data.message, "error");
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const cols = [
    {
      title: "Priority",
      dataIndex: "priority",
      key: "priority",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Rule Name",
      dataIndex: "ruleName",
      key: "ruleName",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Apply to Accounts",
      dataIndex: "appliedTo",
      key: "appliedTo",
      render: (record) => (record ? record : "N/A"),
      // render: (pattrens) => {
      //   if (!pattrens || !Array.isArray(pattrens) || pattrens.length === 0) {
      //     return "N/A";
      //   }
      //   console.log("pattrens",pattrens)
      //   const displayPatterns = pattrens.slice(0, 2).map(item => item.pattern).join(", ");
      //   const suffix = pattrens.length > 2 ? "..." : "";
      //   return `${displayPatterns}${suffix}`;

      // },
    },
    {
      title: "Change Category",
      dataIndex: "changeCategoryTo",
      key: "changeCategoryTo",
      render: (categoryId, record) => {
        if (!categoryId) return "N/A";

        let matchedCategory =
          categories &&
          categories.find((category) => category.id === categoryId);

        // Check for subcategory in the record
        if (record && record.changeSubCategoryTo) {
          let parentCategory;
          let matchedSubCategory;

          categories &&
            categories.forEach((category) => {
              const subCategory =
                category &&
                category.subCategories &&
                category.subCategories.find(
                  (sub) => sub.id === record.changeSubCategoryTo
                );
              if (subCategory) {
                matchedSubCategory = subCategory;
                parentCategory = category;
              }
            });

          return matchedSubCategory
            ? `${parentCategory.categoryName || parentCategory.name} (${matchedSubCategory.name
            })`
            : "N/A";
        }

        // If no subcategory, return the matched category
        return matchedCategory
          ? matchedCategory.categoryName || matchedCategory.name
          : "N/A";
      },
    },
    {
      title: "Apply On",
      dataIndex: "applyOn",
      key: "applyOn",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Change Notes",
      dataIndex: "changeNotesTo",
      key: "changeNotesTo",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Action",
      render: (record, index) => {
        return (
          <div key={index}>
            <Dropdown
              trigger={["click"]}
              overlay={
                <Menu>
                  <Menu.Item>
                    <div
                      onClick={() => {
                        handleUpdateRule(record);
                      }}
                    >
                      Update
                    </div>
                  </Menu.Item>
                  <Menu.Item>
                    <div
                      onClick={() => {
                        deleteRule(record);
                      }}
                    >
                      Delete
                    </div>
                  </Menu.Item>
                </Menu>
              }
            >
              <a
                className="ant-dropdown-link"
                style={{
                  cursor: "pointer",
                  marginRight: "1rem",
                  padding: "0px 16px",
                  width: "5px",
                }}
                onClick={(e) => e.preventDefault()}
              >
                <img src={menuIcon} width={4} height={16} alt="icon"></img>
              </a>
            </Dropdown>
          </div>
        );
      },
    },
  ];
  // ✅ Custom row renderer for drag-and-drop

  const DraggableBodyRow = ({ index, className, style, ...props }) => {
    const { transactionrules } = props; // Get full data source
    const rowKey = props["data-row-key"];
    const record =
      transactionrules && transactionrules.find((item) => item.id === rowKey); // Find index
    if (!record) return <tr {...props} />; // If no record, render normally

    return (
      <Draggable
        key={record && record.id}
        draggableId={record && record.id.toString()}
        index={index}
        style={{ width: "100%" }}
      >
        {(provided, snapshot) => (
          <tr
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            className={`${className} ${snapshot.isDragging ? "dragging" : ""}`}
            style={{
              ...style,
              ...provided.draggableProps.style,
              width: snapshot.isDragging ? "100%" : "auto",
              background: snapshot.isDragging ? "white" : "inherit",
            }}
            {...props}
          />
        )}
      </Draggable>
    );
  };
  const DraggableContainer = (props) => (
    <Droppable droppableId="droppable" direction="vertical" type="ROW">
      {(provided) => (
        <tbody
          ref={provided.innerRef}
          {...provided.droppableProps}
          {...props}
        />
      )}
    </Droppable>
  );

  const tabs = [
    {
      id: 1,
      name: "Before",
    },
    {
      id: 2,
      name: "After",
    },
  ];

  return (
    <div className="addBudgetMain" style={{ position: "relative" }}>
      <div className="addbudgetSection">
        <div className="recurring-pattren-container">
          <div className="addTitle">
            Transaction Rules{" "}
            <span>
              <Dropdown
                trigger={["click"]}
                overlay={
                  <Menu>
                    <Menu.Item>
                      <div
                        onClick={() => {
                          history.push("/budget");
                        }}
                      >
                        Dashboard
                      </div>
                    </Menu.Item>
                    <Menu.Item>
                      <div
                        onClick={() => {
                          history.push("/budget/add/transaction");
                        }}
                      >
                        Transactions
                      </div>
                    </Menu.Item>
                    <Menu.Item>
                      <div
                        onClick={() => {
                          history.push("/budget/add/budget");
                        }}
                      >
                        Budget
                      </div>
                    </Menu.Item>
                    <Menu.Item>
                      <div
                        onClick={() => {
                          history.push("/budget/transaction/recurring");
                        }}
                      >
                        Recurring
                      </div>
                    </Menu.Item>
                  </Menu>
                }
              >
                <a
                  className="ant-dropdown-link"
                  onClick={(e) => e.preventDefault()}
                >
                  <img src={editIcon} height={12} width={18} alt="icon"></img>
                </a>
              </Dropdown>
            </span>
          </div>
          <div className="add-pattren-container">
            <button
              className="addbuttonassets"
              onClick={() => {
                setAddModal(true);
              }}
            >
              {" "}
              + Add Rule
            </button>
          </div>
        </div>
      </div>
      <div className="recurring-token-table">
        <div
          className="budgetcreate"
          style={{ gap: "1rem", justifyContent: "space-between" }}
        >
          <h3 className="incomecardheading">Transaction Rules</h3>
          <div
            style={{
              marginBottom: "0px",
              display: "flex",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            <input
              style={{ marginBottom: "0px", height: "33px" }}
              className="searchStyle"
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                setCurrentPage(1);
              }}
            />
          </div>
        </div>
        <DragDropContext onDragEnd={onDragEnd}>
          <Table
            columns={cols}
            dataSource={transactionrules && transactionrules}
            locale={{ emptyText: "No data to show" }}
            pagination={{
              total: totalPages * 10,
              current: currentPage,
              onChange: setCurrentPage,
              pageSize: 10,
            }}
            rowKey="id"
            components={{
              body: {
                wrapper: DraggableContainer, // Wraps tbody inside Droppable
                row: (props) => {
                  const index =
                    transactionrules &&
                    transactionrules.findIndex(
                      (item) => item.id === props["data-row-key"]
                    );
                  return (
                    <DraggableBodyRow
                      {...props}
                      transactionrules={transactionrules && transactionrules}
                      index={index}
                    />
                  );
                }, // Draggable rows
              },
            }}
          />
        </DragDropContext>
      </div>
      {addModal && (
        <AddTransactionRules
          title={modalTitle && modalTitle}
          open={addModal}
          handleChange={handleInputChange}
          handleCancel={handleCancelRule}
          data={formData && formData}
          handleSave={handleSaveRule}
          banks={clientBanks && clientBanks}
          categories={categories && categories}
        />
      )}
      <Modal
        visible={detailsModal}
        footer={null}
        onOk={handleCancel}
        onCancel={handleCancel}
        closable={false}
        centered
      >
        <h3 className="modaltitle">Transaction Details</h3>

        <div className="tab-containers">
          {tabs.map((tab, index) => (
            <button
              key={index}
              className={
                selectedTab === tab.name
                  ? "before-buttons-active"
                  : "before-buttons"
              }
              onClick={() => {
                setSelectedTab(tab.name);
              }}
            >
              {tab.name}
            </button>
          ))}
        </div>

        <h3 className="inputTitle">
          {affectedTransactions &&
            affectedTransactions.length > 0 &&
            `${affectedTransactions.length} Transations Affected by this Rule`}
        </h3>
        <div>
          <div
            className=""
            style={{ height: "18rem", maxHeight: "18rem", overflow: "auto" }}
          >
            {affectedTransactions && affectedTransactions.length > 0 ? (
              <table id="clients">
                <thead>
                  <tr>
                    <th
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      Date
                    </th>
                    <th>Name</th>
                    <th>Category</th>
                    <th
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      Amount
                    </th>
                  </tr>
                </thead>
                <tbody style={{}}>
                  {affectedTransactions &&
                    affectedTransactions.map((data, index) => (
                      <tr key={index}>
                        <td>
                          {data.date
                            ? moment(data.date).format("MM-DD-YYYY")
                            : "N/A"}
                        </td>
                        <td>
                          {selectedTab === "After"
                            ? (transactionRuleId &&
                              transactionRuleId.changeNameTo &&
                              transactionRuleId.changeNameTo) ||
                            data.itemName ||
                            "N/A"
                            : data.itemName
                              ? data.itemName
                              : "N/A"}
                        </td>
                        <td>
                          {selectedTab === "After"
                            ? (transactionRuleId &&
                              transactionRuleId.categoryName &&
                              transactionRuleId.categoryName) ||
                            data.categoryFromPlaid ||
                            "N/A"
                            : data.categoryFromPlaid
                              ? data.categoryFromPlaid
                              : "N/A"}
                          {selectedTab === "After" &&
                            transactionRuleId &&
                            transactionRuleId.subCategory &&
                            `( ${transactionRuleId.subCategory})`}
                        </td>
                        <td>
                          {" "}
                          ${" "}
                          {data.amount
                            ? `${data.amount
                              .toFixed(2)
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
                            : "0"}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            ) : (
              <h3 className="inputTitle">
                {loading ? "Loading Transactions... " : "No data to show"}
              </h3>
            )}
          </div>
        </div>

        <div className="buttonsMain">
          <button
            className="cancelbutton"
            onClick={() => {
              handleCancel();
            }}
          >
            Close
          </button>
          <button
            className="savebutton"
            onClick={() => {
              handleApplyRule();
            }}
          >
            Apply
          </button>
        </div>
        <NewLoader isLoading={loading} />
      </Modal>
      <NewLoader isLoading={loading} />
    </div>
  );
};
